import axios from 'axios';
import BaseAPI from './base-api';
import DocumentPortalSettings_ from './models/DocumentPortalSettings';

export default class SettingsAPI extends BaseAPI {
  static getDesignTemplateSettings(institutionId: string) {
    return BaseAPI.promiseWrapper<DocumentPortalSettings_>(axios({
      method: 'GET',
      url: `${window.feHost}/api/Setting/GetDesignTemplateSettings`,
      params: { institutionId, },
      headers: this.getRequestHeaders(),
    }));
  }

  static getBrowserTabTitle() {
    return BaseAPI.promiseWrapper<string>(axios({
      method: 'GET',
      url: `${window.feHost}/api/Setting/GetBrowserTabTitle`,
      headers: this.getRequestHeaders(),
    }));
  }

  static getFinancialInstitutionDisclaimersAndFinePrint() {
    return BaseAPI.promiseWrapper<string>(axios({
      method: 'GET',
      url: `${window.feHost}/api/Setting/GetFinancialInstitutionDisclaimersAndFinePrint`,
      headers: this.getRequestHeaders(),
    }));
  }

  static isQDEnabled() {
    return BaseAPI.promiseWrapper<boolean>(axios({
      method: 'GET',
      url: `${window.feHost}/api/Setting/IsQDEnabled`,
      headers: this.getRequestHeaders(),
    }));
  }
}
